import {
	createRouter,
	createWebHistory
} from 'vue-router'

const routerHistory = createWebHistory(process.env.BASE_URL)
const router = createRouter({
	history: routerHistory,
	routes: [
		{
			path: '/',
			meta: { title: '垚鑫淼环境', description: '深圳垚鑫淼环境科技有限公司，专注陶瓷膜、水处理方案与环保技术，提供工业废水、市政污水、农村污水、饮用水等全流程技术服务与AI运维平台。' },
			component: () => import('../views/index/index.vue')
		},
		{
			path: '/contact',
			meta: { title: '联系我们 - 垚鑫淼环境', description: '深圳垚鑫淼环境科技有限公司联系方式，欢迎洽谈陶瓷膜、水处理、环保合作。' },
			component: () => import('../views/contact/contact.vue')
		},
		{
			path: '/news',
			meta: { title: '新闻资讯 - 垚鑫淼环境', description: '垚鑫淼环境新闻与行业资讯，陶瓷膜技术、水处理项目、环保合作动态。' },
			component: () => import('../views/news/news.vue')
		},
		{
			path: '/service',
			meta: { title: '全流程技术服务 - 垚鑫淼环境', description: '垚鑫淼环境提供生产、安装、运营全流程技术服务，陶瓷膜与水处理一站式解决方案。' },
			component: () => import('../views/service/service.vue')
		},
		{
			path: '/product',
			meta: { title: '产品和服务 - 垚鑫淼环境', description: '垚鑫淼环境产品与服务：陶瓷膜、AI运维平台、水处理方案、全流程技术服务。' },
			component: () => import('../views/product/product.vue')
		},
		{
			path: '/waterTreatment',
			meta: { title: '水处理方案 - 垚鑫淼环境', description: 'AI定制化水处理方案，复合菌种与陶瓷膜结合，智能运维，适用于多种废水场景。' },
			component: () => import('../views/product/waterTreatment.vue')
		},
		{
			path: '/ceramicMembrane',
			meta: { title: '陶瓷膜 - 垚鑫淼环境', description: '纳米陶瓷平板膜，寿命长、耐污染、通量大，中国最大的陶瓷膜工厂。' },
			component: () => import('../views/product/ceramicMembrane.vue')
		},
		{
			path: '/industrialWaste',
			meta: { title: '工业废水提标扩容 - 垚鑫淼环境', description: '工业废水提标扩容解决方案，电镀、印染、食品、石化等废水处理案例。' },
			component: () => import('../views/businessField/industrialWaste.vue')
		},
		{
			path: '/municipalSewage',
			meta: { title: '市政污水处理提标改造 - 垚鑫淼环境', description: '市政污水处理厂提标改造，陶瓷膜技术在市政污水领域的应用与案例。' },
			component: () => import('../views/businessField/municipalSewage.vue')
		},
		{
			path: '/ruralSewage',
			meta: { title: '农村生活污水 - 垚鑫淼环境', description: '农村生活污水处理解决方案，智能微动力设备与项目案例。' },
			component: () => import('../views/businessField/ruralSewage.vue')
		},
		{
			path: '/drinkingWater',
			meta: { title: '饮用水 - 垚鑫淼环境', description: '高品质饮用水设备与净化方案，市政与乡村饮用水项目。' },
			component: () => import('../views/businessField/drinkingWater.vue')
		},
		{
			path: '/garbageTransferStation',
			meta: { title: '垃圾中转站渗滤液 - 垚鑫淼环境', description: '垃圾转运站渗滤液废水处理，垃圾中转站废水处理项目案例。' },
			component: () => import('../views/businessField/garbageTransferStation.vue')
		},
		{
			path: '/foodWastewater',
			meta: { title: '餐厨废水 - 垚鑫淼环境', description: '餐厨废水、餐厨垃圾废水处理项目与解决方案。' },
			component: () => import('../views/businessField/foodWastewater.vue')
		},
		{
			path: '/AIPlatform',
			meta: { title: 'AI运维平台 - 垚鑫淼环境', description: 'AI运维平台，预测故障、数据透明、视觉优化与智能调节，助力水处理智能化。' },
			component: () => import('../views/AIPlatform/AIPlatform.vue')
		},
		{
			path: '/about',
			meta: { title: '关于我们 - 垚鑫淼环境', description: '深圳垚鑫淼环境科技有限公司简介，核心价值观、企业使命与陶瓷膜产业布局。' },
			component: () => import('../views/about/about.vue')
		}
	],
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth'
			}
		}
		// 否则滚动到顶部
		return {
			top: 0
		}
	}
})

// SEO：路由切换时更新 title 和 meta description
router.afterEach((to) => {
	const meta = to.meta || {}
	document.title = meta.title ? `${meta.title}` : '垚鑫淼环境'
	const descEl = document.querySelector('meta[name="description"]')
	if (descEl && meta.description) {
		descEl.setAttribute('content', meta.description)
	}
})

export default router
